import React, { useEffect } from "react";
import { TextArea } from "semantic-ui-react";
import { useValidateIsNotEmptyString } from "formvalidation/hooks";
import classNames from "classnames";
import { useSemanticUiTextAreaRef } from "utilities/hookutils";

interface Props {
  value: string
  onChange: (value: string) => void
  maxLength: number
  onBlur?: () => void
  onCtrlEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  disabled?: boolean
  placeholder?: string
  rows?: number
  validatorKey: string
}

const RequiredTextAreaInput = (props: Props) => {
  const textAreaRef = useSemanticUiTextAreaRef();

  const validation = useValidateIsNotEmptyString({
    key: props.validatorKey,
    title: props.validatorKey,
    value: props.value,
    ref: textAreaRef.ref as any,
  })

  useEffect(() => {
    if (props.focusOnMount) {
      textAreaRef.ref.current.focus();
      textAreaRef.ref.current.selectionStart = textAreaRef.ref.current.selectionEnd - textAreaRef.ref.current.value.length;
      textAreaRef.ref.current.scrollTop = textAreaRef.ref.current.scrollHeight;
    }
  }, []);

  const onChange = (_, { value }) => {
    props.onChange(value);
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      props.onEsc?.();
    } else if (e.ctrlKey && e.key === "Enter") {
      props.onCtrlEnter?.();
    }
  }

  const errorClass = classNames({
    "s1_warningborder": validation.error.hasError
  });

  return <TextArea
    className={errorClass}
    style={{ lineHeight: `${16}px` }}
    placeholder={props.placeholder}
    rows={props.rows || 6}
    ref={textAreaRef.refSetter}
    value={props.value}
    onChange={onChange}
    maxLength={props.maxLength}
    onBlur={() => { props.onBlur?.(); }}
    onKeyDown={onKeyDown}
    fluid="true"
    disabled={props.disabled}
  />;
}
export default RequiredTextAreaInput;